<template>
  <div style="width: 100%; padding: 10px;">
    <div style="text-align: left;">
    <div>
      <el-table
        :data="getOrderList"
        style="width: 100%; font-size: 12px;">
        
        <el-table-column 
        prop="sl_no"
        label="#" width="50">
            <template slot-scope="scope"> 
                {{scope.row.key+1}}.
            </template>
        </el-table-column>

        <el-table-column 
        prop="tailoring_detail"
        label="Order Detail" width="150">
            <template slot-scope="scope"> 
                <div v-if="scope.row.tailoring_item_id>0">
                    <div style="display: flex; flex-direction: column;">
                        <span style="font-size: 12px;" v-if="scope.row.tailoring_detail !== null">
                            {{scope.row.tailoring_detail.template_name}}
                        </span>
                        <!--<el-popover
                            placement="right"
                            content="Loading..."
                            trigger="click">
                            <br>
                            <div style="text-align: left;">
                            <span v-html="scope.row.extra_charge_description"></span>
                            </div>
                            <a v-if="isRegularOrder && scope.row.extra_charge_unit_rate>0" slot="reference" style="cursor: pointer; text-decoration: underline;">
                            <span class="rowFontSize">
                                <b>Charges</b>
                            </span>
                            </a>
                        </el-popover>-->
                        
                         <!--<el-button size="small" @click="cost_sheet_view = true">
                                Cost Sheet
                            </el-button>   -->
                            
                    </div>
                </div>
                <div v-else-if="scope.row.retail_item_id>0">
                    <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                        <span style="font-size: 12px;">
                            {{scope.row.retail_detail.sku}}{{scope.row.retail_detail.sku_code}}, {{scope.row.retail_detail.article_name}}
                        </span>
                        <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; flex-wrap: no-wrap;">
                            <!--
                            <el-button size="small" @click="viewStock(scope.row.retail_item_id, scope.row.retail_detail.unit_name+'')">
                                Stock
                            </el-button>   
                             -->
                            <el-button 
                                v-if="scope.row.retail_detail.alteration_allowed" 
                                size="small" 
                                @click="addAlteration(scope.row)">
                                Alter?
                            </el-button> 
                            <el-tag
                                size="small"
                                v-if="!quickView 
                                && (scope.row.retail_detail.fabric_cut_length === 1)
                                && ($store.getters.getSaleMasterDataProps.sale_type === 1 || $store.getters.getSaleMasterDataProps.sale_type === 3)" 
                                @click="showPurchaseRequestWindow(scope.row)" 
                                type="primary"
                                effect="plain"
                                style="cursor: pointer; width: 90px; margin-top: 5px;">
                                PO Request
                            </el-tag>
                        </div>
                                              
                        
                    </div>
                </div>
            </template>
        </el-table-column>

        <el-table-column 
        v-if="!$store.getters.getPreferenceProps.sale_form_reduced"
        label="Qty" align="center">
        
            <template slot-scope="scope"> 
                <div v-if="!quickView && ($store.getters.getSaleMasterDataProps.sale_type !== 2)">
                    <el-input @focus="$event.target.select()"
                        v-if="scope.row.tailoring_item_id>0"
                        :disabled="(scope.row.work_order.length > 0 || scope.row.work_order_id > 0) && scope.row.id>0 && $store.getters.getSaleMasterDataProps.sale_status > 0"
                        @keyup.enter.native="updateQty(scope.row)"
                        @change="updateQty(scope.row)"
                        :id="'sale_qty_'+scope.row.key"
                        v-model="scope.row.tailoring_qty"
                        min="1"
                        size="small"
                        type="number"
                        style="width: 70px; text-align: center;">
                    </el-input>
                    <el-input @focus="$event.target.select()"
                        v-else
                        :disabled="$store.getters.getSaleMasterDataProps.e_cart_id>0"
                        @keyup.enter.native="updateQty(scope.row)"
                        @change="updateQty(scope.row)"
                        :id="'sale_qty_'+scope.row.key"
                        v-model="scope.row.retail_qty"
                        size="small"
                        type="number"
                        min="0"
                        style="width: 70px; text-align: center;">
                    </el-input>
                </div>
                <div v-else>
                    <span v-if="scope.row.tailoring_item_id>0">
                        {{scope.row.tailoring_qty}}
                    </span>
                    <span v-else>
                        {{scope.row.retail_qty}}
                    </span>
                </div>
            </template>
           
                
        </el-table-column>

        <el-table-column
        v-if="$store.getters.getSaleMasterDataProps.sale_type === 3 || $store.state.preferences.props.hide_fabric_consumption_sale_order"
        label="Size" align="center">
        
            <template slot-scope="scope"> 
                <el-select 
                    size="small"
                    @change="updateFabricQty(scope.row)"
                    v-model="scope.row.size_id" 
                    filterable 
                    style="width: 115px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getTailoringSizeList"
                        :key="index"
                        :label="data.size_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.size_name"></span>
                    </el-option>
                </el-select> 
                
            </template>
           
                
        </el-table-column>

        <el-table-column 
        v-if="!$store.getters.getPreferenceProps.sale_form_reduced"
        label="Fabric">
            <template slot-scope="scope"> 
                <div v-if="scope.row.tailoring_item_id>0 && scope.row.fabric_id>0">
                    <div style="display: flex; flex-direction: column;">
                        <el-tag
                            size="small"
                            @click="showFabricChangeWindow(scope.row)" 
                            type="primary"
                            effect="plain"
                            style="cursor: pointer;">
                            {{scope.row.fabric_detail.sku_code}}
                        </el-tag>   
                        <!--<el-button size="small" @click="viewStock(scope.row.fabric_id, scope.row.fabric_detail.unit_name)">
                            Stock
                        </el-button>-->
                    </div>
                </div>
                <div v-else>
                    <span v-html="'&nbsp;'"></span>
                </div>
            </template>
        </el-table-column>

        <el-table-column 
        v-if="!$store.getters.getPreferenceProps.sale_form_reduced 
            && !$store.state.preferences.props.hide_fabric_consumption_sale_order"
        label="Fabric QTY" align="center">
            <template slot-scope="scope"> 
                <div v-if="scope.row.tailoring_item_id>0 && scope.row.fabric_id>0">
                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        <div style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
                            
                            <el-tag
                                size="small"
                                v-if="scope.row.fabric_id>0 && !quickView" 
                                @click="showFabricQtyEditWindow(scope.row)" 
                                type="primary"
                                effect="plain"
                                style="cursor: pointer;">
                                {{scope.row.fabric_unit_qty}} {{scope.row.fabric_detail.unit_name}}
                            </el-tag>
                            <span v-if="scope.row.fabric_id>0 && quickView">
                                {{scope.row.fabric_unit_qty}} {{scope.row.fabric_detail.unit_name}}
                            </span>
                        </div>
                        <!--v-if="scope.row.fabric_id>0 && scope.row.fabric_detail.fabric_cut_length === 1 
                                && (scope.row.fabric_detail.closing_stock === null 
                                        || (scope.row.fabric_detail.closing_stock < (parseFloat(scope.row.fabric_unit_qty)*parseFloat(scope.row.tailoring_qty))))" -->
                        <el-tag
                            size="small"
                            v-if="isRegularOrder 
                            && !quickView 
                            && scope.row.fabric_id>0 
                            && scope.row.fabric_detail !== null 
                            && (scope.row.fabric_detail.fabric_cut_length === 1 || $store.state.preferences.props.allow_stock_fabric_po)
                            && ($store.getters.getSaleMasterDataProps.sale_type === 1 || $store.getters.getSaleMasterDataProps.sale_type === 3)" 
                            @click="showPurchaseRequestWindow(scope.row)" 
                            type="primary"
                            effect="plain"
                            style="cursor: pointer; width: 90px; margin-top: 5px;">
                            PO Request
                        </el-tag>
                        <el-checkbox @change="changeFabricRate(scope.row)" v-model="scope.row.fabric_price_fixed"
                            v-if="(scope.row.tailoring_detail.fabric_sales_price_remains_flat === 1 
                                || scope.row.fabric_detail.stitching_rate_flat) && scope.row.id === 0">
                            Enable Flat Rate
                        </el-checkbox>
                    </div>
                </div>
                <div v-else>
                    <span v-html="'&nbsp;'"></span>
                </div>
            </template>
        </el-table-column>

        <el-table-column 
        v-if="(type === 1 || type === 0) && ($store.getters.getSaleMasterDataProps.sale_type === 1 || $store.getters.getSaleMasterDataProps.sale_type === 3)"
        label="Work Order" align="center">
            <template slot-scope="scope"> 
                <div v-if="scope.row.tailoring_item_id>0">
                    <div style="display: flex; flex-direction: column;">
                        <div style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
                            
                            <el-tag 
                                :loading="true" 
                                size="small"
                                @click="showWorkOrderWindow(scope.row)"
                                v-if="$store.getters.getSaleMasterDataProps.sale_type > 0 && !quickView && scope.row.id>0"
                                :type="(scope.row.work_order.length > 0 || scope.row.work_order_id > 0) ? 'success' : 'primary'"
                                :effect="'plain'"
                                :style="'margin-left: '+(scope.row.fabric_id>0 ? '5px' : '')+'; cursor: pointer;'">
                                <i class="el-icon-loading" 
                                title="Work-order upload is in progress" 
                                v-if="scope.row.wo_processing" style="color: black"></i>
                                <span v-if="scope.row.wo_processing">
                                    ......
                                </span>
                                <span v-else>
                                    {{scope.row.work_order_id > 0 ? 'Open' : scope.row.id >0 ? 'Create' : 'Draft'}}
                                </span>                                
                            </el-tag>
                            <el-tag 
                                :loading="true" 
                                size="small"
                                @click="showWorkOrderWindow(scope.row)"
                                v-else-if="getOrderList.filter(t => t.wo_processing).length === 0 && $store.getters.getSaleMasterDataProps.sale_type > 0 && !quickView && scope.row.id === 0"
                                :type="'primary'"
                                :effect="'plain'"
                                :style="'margin-left: '+(scope.row.fabric_id>0 ? '5px' : '')+'; cursor: pointer;'">                                
                                    Draft
                            </el-tag>
                            <el-tag 
                                size="small"
                                v-else
                                @click="showWorkOrderWindow(scope.row)"
                                :type="'primary'"
                                :effect="'plain'"
                                :style="'margin-left: '+(scope.row.fabric_id>0 ? '5px' : '')+'; cursor: pointer;'">                                
                                    {{scope.row.work_order_id > 0 ? 'Open' : scope.row.id >0 ? 'Create' : 'Draft'}}
                            </el-tag>
                            
                        </div>
                        <el-checkbox v-if="!$store.getters.getPreferenceProps.sale_form_reduced" v-model="scope.row.tailoring_trial_required" :disabled="scope.row.id > 0">
                            Trial Required
                        </el-checkbox>
                        <a 
                            href="javascript:void(0)" 
                            @click="openTrialScheduleWindow(scope.row.id)"
                            style="color: black;" 
                            v-if="scope.row.tailoring_trial_required && scope.row.id>0">
                            <b>Schedule Trials</b>
                        </a>
                    </div>
                </div>
                <div v-else>
                    <span v-html="'&nbsp;'"></span>
                </div>
            </template>
        </el-table-column>

        <el-table-column 
        v-if="$store.getters.getSaleCategoryList.length>1 && !quickView && ($store.getters.getSaleMasterDataProps.sale_type === 1)"
        prop="sale_category_id"
        label="Sale Category">
        
            <template slot-scope="scope"> 
                <el-select 
                    v-if="($store.state.preferences.props.sale_category_required_retail_sale && scope.row.retail_item_id>0) || scope.row.tailoring_item_id>0"
                    size="small"
                    v-model="scope.row.sale_category_id" 
                    filterable 
                    style="width: 115px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getSaleCategoryList"
                        :key="index"
                        :label="data.category_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.category_name"></span>
                    </el-option>
                </el-select>                
            </template>
                
        </el-table-column>

        <el-table-column
        v-if="$store.getters.getSaleMasterDataProps.tax_id>0 && (($store.getters.getSaleMasterDataProps.sale_type === 0 || $store.getters.getSaleMasterDataProps.sale_type === 1))  && !quickView"
        prop="tax_percent"
        :label="($store.getters.isIndiaTax ? 'GST (%)' : $store.getters.getSaleMasterDataProps.tax_detail.tax_name+' (%)')" 
        align="center">
            <template slot-scope="scope">
                {{scope.row.tax_percent}} %
            </template>
        </el-table-column>

        <el-table-column
        prop="unit_rate"
        :label="'Total ('+getCurrencyFormat.currency_symbol+')'" 
        align="center" width="200" v-if="($store.getters.getSaleMasterDataProps.sale_type === 0 || $store.getters.getSaleMasterDataProps.sale_type === 1 || $store.getters.getSaleMasterDataProps.sale_type === 2) && !quickView">
            <template slot-scope="scope">
                <!--
                    style="color: black; border: 1px solid #e2e2e2; text-align: center; cursor: pointer;"-->
                <div v-if="!$store.getters.getPreferenceProps.sale_form_reduced">
                    <el-tag 
                        size="small"
                        @click="showPriceEditWindow(scope.row)"
                        v-if="$store.getters.getSaleMasterDataProps.e_cart_id === 0"
                        :type="'primary'"
                        :effect="'plain'"
                        :style="'cursor: pointer;'">                                
                            <span v-html="formatCurrency(parseFloat(scope.row.net_total))"></span>
                    </el-tag>                   
                </div>  
                <span v-else v-html="formatCurrency(parseFloat(scope.row.net_total))"></span>

                <div v-if="scope.row.discount_amount>0">
                    <b style="color: red; font-size: 10px;">-{{formatCurrency(scope.row.discount_amount)}}</b>
                </div>           
                <div v-else-if="scope.row.discount_amount === 0 
                    && (scope.row.fabric_unit_discount_amount>0 || scope.row.tailoring_unit_discount_amount>0)">
                    <b style="color: red; font-size: 10px;">-{{formatCurrency((scope.row.fabric_unit_discount_amount*parseFloat(scope.row.fabric_unit_qty)*scope.row.tailoring_qty)+(scope.row.tailoring_unit_discount_amount*scope.row.tailoring_qty))}}</b>
                </div>           
                <div v-else-if="scope.row.discount_amount === 0 
                    && (scope.row.retail_unit_discount_amount>0 )">
                    <b style="color: red; font-size: 10px;">-{{formatCurrency((scope.row.retail_unit_discount_amount))}}</b>
                </div>           
            </template>
        </el-table-column>

        <el-table-column
        prop="unit_rate"
        :label="'Total ('+getCurrencyFormat.currency_symbol+')'" 
        align="center" width="200" v-if="(isRegularOrder || $store.getters.getSaleMasterDataProps.sale_type === 0) && quickView">
            <template slot-scope="scope">
                <div 
                    style="color: black; text-align: center; cursor: pointer;">
                    <b>{{formatCurrency(parseFloat(scope.row.net_total))}}</b>
                </div>   
                <div v-if="scope.row.discount_amount>0">
                    <b style="color: red; font-size: 10px;">-{{formatCurrency(scope.row.discount_amount)}}</b>
                </div>           
            </template>
        </el-table-column>

        <el-table-column
            label="" v-if="!quickView && $store.getters.getSaleMasterDataProps.e_cart_id === 0">
            <template slot-scope="scope">
                <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                    
                    <el-tooltip class="item" effect="dark" content="Notes" style="margin-right: 10px;">
                        <a @click="openNoteView(scope.row)" style="cursor: pointer;">
                            <i :class="'el-icon-s-claim'" style="font-size: 16px;"></i>
                        </a>
                    </el-tooltip>
                    
                    <el-tooltip class="item" effect="dark" content="Cost Analysis" style="margin-left: 10px;">
                        <a v-if="scope.row.id>0 && scope.row.tailoring_item_id>0 && scope.row.work_order_id" @click="openCostSheet(scope.row)" style="cursor: pointer;">
                        <i :class="'el-icon-pie-chart'" style="font-size: 16px;"></i>
                        </a>
                    </el-tooltip>
                    
                    <el-tooltip class="item" effect="dark" content="Copy" style="margin-left: 10px;">
                        <el-popconfirm
                            @confirm="copyOrderRow(scope.row)"
                            :title="'Are you sure to copy?'"
                            >
                        <a slot="reference" style="cursor: pointer;">
                        <i :class="'el-icon-document-copy'" style="font-size: 16px;"></i>
                        </a>
                        </el-popconfirm>
                    </el-tooltip>
                        
                    <el-tooltip class="item" effect="dark" :content="(scope.row.id>0 
                            && scope.row.tailoring_item_id >0 
                                && $store.getters.getSaleMasterDataProps.sale_type>0 ? 'Cancel' : 'Delete')">
                        <el-popconfirm
                            @confirm="deleteListItem(scope.row)"
                            :title="'Are you sure to '+(scope.row.id>0 
                                && scope.row.tailoring_item_id >0 
                                    && $store.getters.getSaleMasterDataProps.sale_type>0 ? 'cancel' : 'delete')+' this?'"
                            >
                            <div>
                                Once cancelled cannot be undone.
                            </div>
                            <a v-if="(!scope.row.is_cancelled && scope.row.tailoring_item_id >0 && scope.row.work_order_id >= 0) 
                                    || scope.row.retail_item_id>0 
                                        || (scope.row.tailoring_item_id === 0 && scope.row.retail_item_id === 0)
                                            && (
                                                ($store.getters.getSaleMasterDataProps.id>0 && $store.getters.getSaleMasterDataProps.sale_status === 1 && $store.getters.getAccessRights.can_delete) 
                                                || ($store.getters.getSaleMasterDataProps.id>0 && $store.getters.getSaleMasterDataProps.sale_status === 0) 
                                                || ($store.getters.getSaleMasterDataProps.id === 0) 
                                            )" slot="reference" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                                <i class="el-icon-delete"></i>
                            </a>
                            
                        </el-popconfirm>
                    </el-tooltip>
                    
                </div>                                      
            </template>
        </el-table-column>
        </el-table>
    </div>
    </div>   

    <el-dialog
        v-if="getRowData !== null && showFabricQtyWindow"
        width="70%"
        :visible.sync="showFabricQtyWindow"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        append-to-body
        :show-close="false">
        <EditFabricQty 
            :rowData="getRowData"
            @closed="closeWindow"/>
    </el-dialog>

    <el-dialog
        v-if="getRowData !== null && showPriceWindow"
        width="550px"
        :visible.sync="showPriceWindow"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        append-to-body
        :show-close="false">
        <EditPrice
            :rowData="getRowData"
            @closed="closeWindow"/>
    </el-dialog>

    <el-dialog
        v-if="getRowData !== null && showPurchaseRequest"
        width="400px"
        :visible.sync="showPurchaseRequest"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        append-to-body
        :show-close="false">
        <PurchaseRequest
            :rowData="getRowData"
            @closed="closeWindow"/>
    </el-dialog>

    <el-dialog
        :title="'Work-Order: '+getRowData.tailoring_detail.template_name"
        v-if="getRowData !== null && showWorkOrder"
        fullscreen
        :visible.sync="showWorkOrder"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        append-to-body
        :show-close="false">
        <WorkOrder
            :wo_confirmed="isWOConfirmed"
            :popup="true"
            :sale_item_index="getRowData.key"
            @closed="closeWindow"/>
    </el-dialog>

    <el-dialog
        v-if="showFabric"
        width="70%"
        height="400px"
        :visible.sync="showFabric"
        append-to-body>
            <FabricChange 
                :title="'Choose Fabric For '+getRowData.tailoring_detail.template_name"
                :popup="true"
                :rowData="getRowData"
                @closed="showFabric = false"/>
      </el-dialog>

      <el-dialog
        :title="'Cost Sheet'"
        v-if="cost_sheet_view"
        width="70%"
        height="400px"
        :visible.sync="cost_sheet_view"
        append-to-body>
            <CostSheet :rowData="getRowData" />
      </el-dialog>

      <el-dialog
        v-if="show_stock_list && !$store.getters.getLoadingState"
        width="450px"
        height="400px"
        :visible.sync="show_stock_list"
        append-to-body>
 
            <div style="display: flex; flex-direction: column;">
                <div 
                    v-for="(data, index) in $store.state.inventoryMaster.stock_list" 
                    :key="index" 
                    style="margin: 2px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; border-bottom: 1px solid #e2e2e2;">
                    <span>
                        {{data.store_name}}
                    </span>
                    <span>
                        {{data.stock}}
                    </span>
                     
                </div>
            </div>
      </el-dialog>

      <el-dialog
        :title="'Notes'"
        v-if="note_window"
        width="450px"
        height="400px"
        :visible.sync="note_window"
        append-to-body>
            
            <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                <div style="margin-top: 0px;">
                    <el-input @focus="$event.target.select()"
                        type="textarea"
                        rows="5"
                        v-model="rowData.notes"
                        style="width: 400px;">
                    </el-input>
                </div>
                <el-button @click="note_window=false" size="small" type="primary" style="margin-top: 10px;">
                    Ok
                </el-button>
            </div>

      </el-dialog>

        <el-dialog
            :title="'Trial Schedule'"
            v-if="trial_schedule"
            width="700px"
            height="400px"
            :visible.sync="trial_schedule"
            append-to-body>
                <TrialSchedule :selected_list_item_id="getSelectedListItemId" />
        </el-dialog>

  </div>
</template>

<script>
import EditFabricQty from './EditFabricQty.vue'
import EditPrice from './EditPrice'
import PurchaseRequest from './PurchaseRequest'
import WorkOrder from '../../../WorkOrder/Index.vue'
import FabricChange from './FabricChange.vue'
import CostSheet from '../CostSheet/Index.vue'
import TrialSchedule from './TrialSchedule'

export default {
    components: {CostSheet, EditFabricQty, FabricChange, EditPrice, PurchaseRequest, WorkOrder, TrialSchedule},
    props: ['currency_symbol', 'quickView', 'type'],
    data() {
        return {
            showFabricQtyWindow: false,
            showPriceWindow: false,
            rowData: null,
            showPurchaseRequest: false,
            showWorkOrder: false,
            wo_confirmed: false,
            showFabric: false,
            rowDataCreate: null,
            show_stock_list: false,
            cost_sheet_view: false,
            note_window: false,
            trial_schedule: false,
            selected_list_item_id: 0
        }
    },
    computed: {
        getSelectedListItemId() {
            return this.selected_list_item_id
        },
        isWOConfirmed() {
            return this.wo_confirmed
        },
        getRowData() {
            return this.rowData
        },
        getRowDataCreate() {
            return this.rowDataCreate
        },
        isRegularOrder() {
            return (this.$store.getters.getSaleMasterDataProps.sale_type === 1)
        },
        getOrderList() {
            
            if(this.type >0) {
                if(this.type === 1) {
                    return this.$store.getters.getSaleMasterDataProps.item_list.filter(t => t.tailoring_item_id>0) 
                } else if(this.type === 2) {
                    return this.$store.getters.getSaleMasterDataProps.item_list.filter(t => t.retail_item_id>0) 
                }
            }
            return this.$store.getters.getSaleMasterDataProps.item_list     

        }
    },
    methods: {
        openTrialScheduleWindow(selected_list_item_id) {
            this.selected_list_item_id = selected_list_item_id
            this.trial_schedule = true
        },
        openNoteView(rowData) {

            this.rowData = rowData

            this.note_window = true

        },
        openCostSheet(rowData) {
            this.rowData = rowData
            this.cost_sheet_view = true
        },
        copyOrderRow(rowData) {
            let rowDataCopy = JSON.parse(JSON.stringify(rowData))
        
            if(rowDataCopy.work_order_id !== null && rowDataCopy.work_order_id !== undefined && rowDataCopy.work_order_id >0) {
                //this.showWorkOrderWindow(rowDataCopy, true)                       
            }
            
            this.$store.commit('copyNewSaleMasterOrderItem', rowDataCopy)            
        },
        deleteListItem(rowData) {

            this.$store.commit('removeSaleMasterItemListRow', rowData.key)    

            /*if(rowData.id >0 && rowData.tailoring_item_id>0 && this.$store.getters.getSaleMasterDataProps.sale_type>0) {

                rowData.is_cancelled = 1
                rowData.tailoring_unit_rate = -rowData.tailoring_unit_rate
                rowData.tailoring_unit_discount_amount = -rowData.tailoring_unit_discount_amount
                rowData.extra_charge_unit_rate = -rowData.extra_charge_unit_rate
                rowData.extra_charge_unit_discount_amount = -rowData.extra_charge_unit_discount_amount
                rowData.fabric_unit_rate = -rowData.fabric_unit_rate
                rowData.fabric_unit_discount_amount = -rowData.fabric_unit_discount_amount
                rowData.retail_unit_rate = -rowData.retail_unit_rate
                rowData.retail_unit_discount_amount = -rowData.retail_unit_discount_amount

                rowData.tailoring_tax_percent = -rowData.tailoring_tax_percent
                rowData.fabric_tax_percent = -rowData.fabric_tax_percent
                
            } else {
                
                    
            }*/
            setTimeout(() => {
                this.$store.commit('editRowCalculations')    
            }, 200);    
        },
        showFabricQtyEditWindow(rowData) {
            this.rowData = rowData
            this.showFabricQtyWindow = true
        },
        showPurchaseRequestWindow(rowData) {
            this.rowData = rowData
            this.showPurchaseRequest = true
        },
        showWorkOrderWindow(rowData, copy_request=false) {

            rowData.sale_id = this.$store.getters.getSaleMasterDataProps.id;
            rowData.store_id = this.$store.getters.getSaleMasterDataProps.store_id;
            rowData.fabricPriceSlabExists = this.$store.getters.getFabricPriceSlabList.length>0
                    
            if(rowData.id === 0) {
                /*
                if(this.$store.getters.getSaleMasterDataProps.sale_status === 0) {
                    this.$emit('saveDraft')
                } else if(this.$store.getters.getSaleMasterDataProps.sale_status === 1) {
                    this.$emit('saveOrder')
                }*/

                if(this.$store.getters.getSaleMasterDataProps.id === 0) {
                        this.$store.dispatch('submitShortcutSale', {
                            props: this.$store.getters.getSaleMasterDataProps,
                            newSaleItemProps: rowData
                        })                    
                } else {
                    this.$store.dispatch('submitNewSaleItem', rowData)
                }
                rowData.wo_processing = true
                
            } else {
                this.wo_confirmed = false

                if(this.checkIfModuleAccessAvailable('/manageworkorders', rowData.work_order.length === 0 ? 'can_add' : 'can_view')) {
                    this.$store.commit('resetSingleWorkOrderData')
                    this.rowData = rowData
                    /*if(rowData.work_order.length > 0) {
                        this.$store.state.workOrder.props = rowData.work_order
                    } else {*/
                        
                        this.$store.dispatch('fetchSingleWorkOrder', {
                            work_order_id: rowData.work_order_id,
                            sale_item_id: rowData.id,
                            tailoring_item_id: rowData.tailoring_item_id,
                            customer_id: this.$store.getters.getSaleMasterDataProps.customer_id,
                            combination_item: rowData.is_combination_tailoring_item,
                            combination_item_list: rowData.combination_item_list,
                            download_request: copy_request
                        })
                    
                    //}

                    if(rowData.work_order.length > 0 || rowData.work_order_id > 0) {
                        this.wo_confirmed = true
                    }

                    this.showWorkOrder = true
                    
                }
            }
        },
        showPriceEditWindow(rowData) {
            if((this.$store.getters.getSaleMasterDataProps.sale_type === 0 
                || this.$store.getters.getSaleMasterDataProps.sale_type === 1) 
                    && this.$store.getters.getSaleMasterDataProps.e_cart_id === 0) {
                this.rowData = rowData
                this.showPriceWindow = true
            } else {
                this.$store.commit('displayMessageAlert', {message: 'Price editing is not allowed!!!', type: 'Warning'})
            }
        },
        updateQty(rowData) {
            this.$store.commit('editRowCalculations')
            //this.changeFocus('sale_net_total_'+key)
            setTimeout(() => {
                if(this.$store.state.preferences.props.sale_step_post_qty === 0) {
                    this.showPriceEditWindow(rowData)
                } else if(this.$store.state.preferences.props.sale_step_post_qty === 1) {
                    this.changeFocus('item_search_field')
                } else if(this.$store.state.preferences.props.sale_step_post_qty === 2) {
                    
                    let itemType = this.type
                    if(itemType === 1) {
                        itemType = 0
                    }
                    if(document.getElementById('item_search_field'+itemType)) {
                        this.changeFocus('item_search_field'+itemType)
                    } else {
                        this.changeFocus('item_search_field')
                    }
                    
                }
            }, 200);            
        },
        updateNetTotal(rowData) {

            let copyRowData = JSON.parse(JSON.stringify(rowData))
            let taxPercent = parseFloat(rowData.tax_percent)
            rowData.alter_net_total = parseFloat(copyRowData.edit_net_total)
            let alter_net_sale_total = rowData.alter_net_total

            let totalAmountBeforeTax = 0

            totalAmountBeforeTax = alter_net_sale_total-((alter_net_sale_total/(100+taxPercent))*taxPercent)
            
            if(parseFloat(rowData.retail_item_id)>0) {
                rowData.tailoring_unit_rate = 0
                rowData.tailoring_qty = 0
                rowData.fabric_unit_rate = 0
                rowData.fabric_unit_qty = 0
            } else if(parseFloat(rowData.tailoring_item_id)>0) {
                rowData.retail_qty = 0
            }

            rowData.discount_amount = 0
            rowData.discount_percent = 0
            rowData.extra_amount = 0
            rowData.extra_amount_reason = ""
            rowData.extra_charge_unit_rate = 0
            rowData.extra_charge_unit_discount_amount = 0

            let tailoring_unit_rate = parseFloat(rowData.tailoring_unit_rate)  
            let tailoring_qty = parseInt(rowData.tailoring_qty)  
            let totalTailoringPrice = tailoring_unit_rate*parseFloat(tailoring_qty)

            let fabric_unit_rate = parseFloat(rowData.fabric_unit_rate)    
            let fabric_unit_qty = parseFloat(rowData.fabric_unit_qty)
            let totalFabricPrice = (fabric_unit_rate*(fabric_unit_qty*tailoring_qty))

            if(fabric_unit_qty>0) {
                let priceForFabric = totalAmountBeforeTax-totalTailoringPrice                
                totalFabricPrice = priceForFabric

                rowData.fabric_unit_rate = totalFabricPrice/(fabric_unit_qty*tailoring_qty)
            } else if(tailoring_qty>0) {
                rowData.tailoring_unit_rate = totalAmountBeforeTax/tailoring_qty
            } else if(rowData.retail_qty>0) {
                rowData.retail_unit_rate = totalAmountBeforeTax/parseFloat(rowData.retail_qty)
            }

            this.$store.commit('editRowCalculations')
            this.showFabricQtyWindow = false
            this.showPriceWindow = false
            this.showPurchaseRequest = false
            this.showWorkOrder = false
            
            this.changeFocus('item_search_field')
        },
        closeWindow() {
            this.$store.commit('editRowCalculations')
            this.showFabricQtyWindow = false
            this.showPriceWindow = false
            this.showPurchaseRequest = false
            this.showWorkOrder = false
        },
        updateFabricQty(rowData) {

            let selectedTailoring = rowData.tailoring_detail

            let required_fabric_unit = selectedTailoring.required_fabric_unit
            if(selectedTailoring.fabric_unit_remain_flat === 0 && rowData.fabric_info !== null) {
                let fabricConsumptionIndex = selectedTailoring.fabric_consumption_list.findIndex((t) => t.size_id == rowData.size_id && t.fabric_width_id == selectedTailoring.selected_fabric.fabric_width_id)
                if(fabricConsumptionIndex>=0) {
                    required_fabric_unit = selectedTailoring.fabric_consumption_list[fabricConsumptionIndex].required_fabric_unit
                }
            }

            rowData.fabric_unit_qty = required_fabric_unit

        },
        showFabricChangeWindow(rowData) {
            this.rowData = rowData
            this.showFabric = true
            
        },
        changeFabricRate(rowData) {
            if(rowData.tailoring_detail.fabric_sales_price_remains_flat === 1 
                || rowData.fabric_detail.stitching_rate_flat && !rowData.fabric_price_fixed) {
                rowData.fabric_actual_rate = rowData.fabric_detail.flat_price ? rowData.fabric_detail.flat_price : 0
                let fabricUnitSalePrice = (parseFloat(rowData.fabric_actual_rate))
                rowData.fabric_unit_rate = fabricUnitSalePrice
            } else if(rowData.tailoring_detail.fabric_sales_price_remains_flat === 1 
                || rowData.fabric_detail.stitching_rate_flat && rowData.fabric_price_fixed) {
                rowData.fabric_actual_rate = rowData.fabric_detail.sale_price
                let fabricUnitSalePrice = (parseFloat(rowData.fabric_actual_rate)/parseFloat(rowData.fabric_unit_qty))
                rowData.fabric_unit_rate = fabricUnitSalePrice
            }
            this.$store.commit('editRowCalculations')
        },
        async viewStock(item_code, unit_name) {
            await this.$store.dispatch('fetchSingleItemStock', {item_code: item_code, unit_name, store_list: this.$store.getters.getAccessibleStoreList})
            setTimeout(() => {
                this.show_stock_list = true
            }, 1000);
        },
        addAlteration(rowData) {

            let retail_detail = JSON.parse(JSON.stringify(rowData.retail_detail))
            
            let template_name = retail_detail.tailoring_detail.template_name+', '+retail_detail.sku_code
            retail_detail.tailoring_detail.template_name = template_name
            retail_detail.tailoring_detail.is_fabric_required = 0    
            retail_detail.tailoring_detail.required_fabric_unit = 0
            retail_detail.tailoring_detail.selected_fabric = {id: 0, sku_code: '', article_name: "", profile_photo: "", cost_price: null, 
            sale_price: 0, unit_of_measurement_id: 0, composition: "", fabric_width_id: 0, fabric_price_category_id: null, hsn_sac_code: "", 
            tax_percent: 0, fabric_cut_length: 0, item_type: 1, stitching_rate_flat: false, discount_percent: 0, flat_price: 0, 
            default_retail_fabric_unit: 0, unit_name: "", closing_stock: 0}

            this.$store.commit('addNewSaleMasterOrderItem', {
                item_type: 0,
                sale_step_post_qty: this.$store.state.preferences.props.sale_step_post_qty,
                selected_item: retail_detail.tailoring_detail
            })
            setTimeout(() => {
                this.$store.commit('editRowCalculations')    
            }, 300);
            
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/SaleMaster/Form/OrderItem/OrderList.vue